import React, { useState } from 'react';
import ReactCrop from 'react-image-crop';

import './imageCropper.scss';

const ImageCropper = props => {
  const [crop, setCrop] = useState({
    unit: '%',
    width: 30,
    aspect: props.aspect || 1,
  });
  const [imgRef, setImgRef] = useState(null);

  // If you setState the crop in here you should return false.
  const onImageLoaded = image => {
    setImgRef(image);
  };

  const onCropComplete = crop => {
    makeClientCrop(crop);
  };

  const onCropChange = crop => {
    setCrop(crop);
  };

  const makeClientCrop = async crop => {
    if (imgRef && crop.width && crop.height) {
      const croppedImageUrl = await getCroppedImg(imgRef, crop, 'newFile.jpeg');
      props.onCropComplete(croppedImageUrl);
    }
  };

  const getCroppedImg = (image, crop, fileName) => {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          return;
        }
        blob.name = fileName;
        resolve(blob);
      }, 'image/jpeg');
    });
  };

  return (
    <ReactCrop
      src={props.src}
      crop={crop}
      onImageLoaded={onImageLoaded}
      onComplete={onCropComplete}
      onChange={onCropChange}
    />
  );
};

ImageCropper.defaultProps = {
  src: null,
  onCropComplete: () => {},
};

export default ImageCropper;
